import { Component } from 'react';
import { Svg } from '../Gauge';
import { formatLabelIdAndId, GaugeCoordinates, GaugeElementId, updateLabelColorById, updateLabelTextById } from '../shared/GaugeShared';

export interface GaugeRightHorizontalLabelProps {
   svg: Svg;
   svgId: string;
   labelsColor: string;
   rightHorizontalLabel: string;
}

export class GaugeRightHorizontalLabel extends Component<GaugeRightHorizontalLabelProps> {
   private RIGHT_HORIZONTAL_LABEL_POSITION: GaugeCoordinates = {
      x: 100,
      y: 44
   };
   private RIGHT_HORIZONTAL_LABEL_SIZE = 11;
   private RIGHT_HORIZONTAL_LABEL_WEIGHT = 'bold';

   constructor(props: GaugeRightHorizontalLabelProps) {
      super(props);

      this.drawGaugeRightHorizontalLabel(props);
   }

   render(): null {
      return null;
   }

   UNSAFE_componentWillReceiveProps(nextProps: GaugeRightHorizontalLabelProps): void {
      this.updateGaugeRightHorizontalLabel(nextProps);
   }

   drawGaugeRightHorizontalLabel = (props: GaugeRightHorizontalLabelProps): void => {
      props.svg.draw.text(props.rightHorizontalLabel)
         .attr({
                  id: formatLabelIdAndId(GaugeElementId.RIGHT_HORIZONTAL_LABEL, props.svgId)
               })
         .move(this.RIGHT_HORIZONTAL_LABEL_POSITION.x, this.RIGHT_HORIZONTAL_LABEL_POSITION.y)
         .font({
                  fill: props.labelsColor,
                  size: this.RIGHT_HORIZONTAL_LABEL_SIZE,
                  weight: this.RIGHT_HORIZONTAL_LABEL_WEIGHT,
                  anchor: 'start',
                  family: 'sans-serif'
               });
   };

   updateGaugeRightHorizontalLabel = (props: GaugeRightHorizontalLabelProps): void => {
      updateLabelTextById(formatLabelIdAndId(GaugeElementId.RIGHT_HORIZONTAL_LABEL, props.svgId), props.rightHorizontalLabel);
      updateLabelColorById(formatLabelIdAndId(GaugeElementId.RIGHT_HORIZONTAL_LABEL, props.svgId), props.labelsColor);
   };
}
